import React, { Component } from "react";
import {
  withStyles,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  AppBar
} from "@material-ui/core";
import Axios from "axios";
import { apiURL } from "../util/config";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import { Line } from "react-chartjs-2";

const styles = theme => ({
  root: {}
});

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

class Views extends Component {
  state = {
    viewData: {},
    value: 1,
    monthData: [],
    dayData: []
  };

  async componentDidMount() {
    let viewData = [];

    await Axios.get(apiURL + "/View/GetViews", {})
      .then(res => {
        viewData = res.data;
      })
      .catch(err => {
        console.log(err);
      });


      let monthData = [];
      let months = [];

      for (let i = 0; i < 12; i++) {
        months.push({views: 0});
      }

      viewData.viewList.forEach((view) => {

        const createdDate = new Date(view.createdOn);
        months[createdDate.getMonth()].views++;

      });
      months.forEach((month, index) => {

        monthData.push({x: index, y: month.views});

      });


      let days = [];
      let currentDate = new Date();
      let day = currentDate.getDate();
      for (let i = 0; i <= day; i++) {
        days.push({views: 0});
      }
      let dayData = [];

      viewData.viewList.forEach((view) => {

        const createdDate = new Date(view.createdOn);
        if (createdDate.getMonth() === currentDate.getMonth())
          days[createdDate.getDate()-1].views++;

      });

      days.forEach((day, index) => {

        dayData.push({x: index, y: day.views});

      });


    this.setState({ viewData: viewData, monthData: monthData, dayData: dayData });


  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes, theme } = this.props;

    const monthData = {
      labels: months,
      datasets: [
        {
          label: "Views",
          data: this.state.monthData
        }
      ]
    };


    const monthOptions = {
      title: {
        display: true,
        text: "Monthly"
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              show: true,
              labelString: "Month"
            }
          }
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              show: true,
              labelString: "Views"
            }
          }
        ]
      }
    };

    let day = new Date().getDate();
    let days = [];

    for (let i = 0; i < day; i++) {
      days.push((i+1)+"");
    }
    const dayData = {
      labels: days,
      datasets: [
        {
          label: "Views",
          data: this.state.dayData
        }
      ]
    };


    const dayOptions = {
      title: {
        display: true,
        text: "Daily"
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              show: true,
              labelString: "Month"
            }
          }
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              show: true,
              labelString: "Views"
            }
          }
        ]
      }
    };

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Table" />
            <Tab label="Monthly Graph" />
            <Tab label="Daily Graph" />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis="x"
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
        >
          <TabContainer>
            <Typography variant="body1">
              Total views: {this.state.viewData.views}
            </Typography>
            <Typography variant="body1">Last 100 Views:</Typography>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>IP Address</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Region</TableCell>
                  <TableCell>Country</TableCell>
                  <TableCell>Organization</TableCell>
                  <TableCell>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.viewData.viewList &&
                  this.state.viewData.viewList.slice(-100).reverse().map(view => {
                    const date = new Date(view.createdOn);

                    return (
                      <TableRow key={view.viewId}>
                        <TableCell>{view.ipData.ip} </TableCell>
                        <TableCell>{view.ipData.city}</TableCell>
                        <TableCell>{view.ipData.region}</TableCell>
                        <TableCell>{view.ipData.country_name}</TableCell>
                        <TableCell>{view.ipData.organisation}</TableCell>
                        <TableCell>{date.toLocaleString()}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TabContainer>

          <TabContainer>
            {this.state.monthData.length > 0 && <Line data={monthData} options={monthOptions} />}
          </TabContainer>

          <TabContainer>

            {this.state.dayData.length > 0 &&<Line data={dayData} options={dayOptions} />}

          </TabContainer>
        </SwipeableViews>
      </div>
    );
  }
}

export default withStyles(styles)(Views);